export default {
	confirmation: {
		accept: { PROXY: 'Yes, cancel my bid', SALE: 'Yes, cancel my offer' },
		deny: 'No, keep it',
		message: {
			PROXY: 'You are about to cancel your bid of {amount}.\n Do you want to continue?',
			SALE: 'You are about to cancel your offer of {amount}.\n Do you want to continue?',
		},
	},
	title: {
		PROXY: 'Cancel your bid',
		SALE: 'Cancel your offer',
	},
};
